
























    import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import bookingDefault from '@/instance-defaults/bookingDefault';
import {BOOKING_STATUS, CALENDAR_FORMAT, CLAIM_STATUS, multiNil, nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import BookingGoogleMapsMixin from '@/mixins/BookingGoogleMapsMixin.vue';
import VendorBox from '@/components/Views/Vendor/VendorBox.vue';
import vendorDefault from '@/instance-defaults/vendorDefault';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {DateTime} from 'luxon';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import PaymentBadge from '@/components/Views/UI/PaymentBadge.vue';
    import BookingMetadataMixin from "@/mixins/BookingMetadataMixin.vue";
    import CardholderInfoBadge from "@/components/Views/UI/CardholderInfoBadge.vue";
    import BookingDateMixin from '@/mixins/BookingDateMixin.vue';
@Component({
    components: {
        CardholderInfoBadge,
        PaymentBadge,
        VendorBox,
    },
})
export default class BookingCard extends Mixins(BookingGoogleMapsMixin, BookingDateMixin, ScreenSizeMixin, CurrencyMixin, BookingMetadataMixin) {

    @Prop({default: 10})
    public elevation!: number;

    @Prop({default: bookingDefault})
    public booking!: any;
    public mapHeight = this.windowHeight();
    public mapWidth = this.windowWidth();
    public cardHolderName = null;
    public displayLocal = false;

    public mounted(){
        this.getCustomerInfo();
    }
    public created(){
        this.getCustomerInfo();
    }

    @Watch('booking')
    public onBookingChanged(booking: any, oldBooking:any) {
        this.getCustomerInfo();
    }

    public async getCustomerInfo(){
        if(nil(this.booking) || nil(this.booking._id) || !nil(this.cardHolderName)){
            return;
        }
        this.cardHolderName = await this.getCardHolderName(this.booking);
    }
    public get tzLabel(){
        return `Displaying ${this.displayLocal ? "Local": "Booking"} Timezone`
    }
    public get proPayment() {
        if (nil(this.booking)) { return 0; }
        const cost = this.calculateBookingPrice(this.booking);
        const tip = cost * .2;
        const pay = cost * this.tierCut;
        return tip + pay;
    }
    public get serviceName() {
        if (multiNil(this, 'booking.purchasableModel')) { return ''; }
        return this.booking.purchasableModel.name;
    }
    public get location() {
        if (multiNil(this, 'booking.address')) { return ''; }
        return this.booking.address;
    }
    public get guests() {
        if (multiNil(this, 'booking.guests')) { return ''; }
        return this.booking.guests;
    }
    public get hours() {
        if (multiNil(this, 'booking.duration')) { return ''; }
        return `${this.booking.duration} hour${this.booking.duration > 1 ? 's' : ''}`;
    }
    public get friendlyDate() {
        if (multiNil(this, 'booking.date')) { return ''; }
        return this.activeBookingDate.toLocaleString(DateTime.DATE_HUGE);
    }
    public get friendlyTime() {
        if (multiNil(this, 'booking.date')) { return ''; }
        return this.activeBookingDate.toLocaleString(DateTime.TIME_SIMPLE);
    }

    get activeBookingDate(){
        return this.displayLocal ? this.zonedBookingDate.toLocal() : this.zonedBookingDate;
    }
    get bookingTimezone(){
        return this.activeBookingDate.toFormat('z');
    }

    public get tierName() {
        if (multiNil(this, 'booking.purchasableModel.tierModel.name')) { return ''; }
        return this.booking.purchasableModel.tierModel.name;
    }
    public get tierCut() {
        if (multiNil(this, 'booking.purchasableModel.tierModel.name')) { return 1; }
        return this.booking.purchasableModel.tierModel.vendorCut;
    }
    public get categoryName() {
        if (multiNil(this, 'booking.purchasableModel.categoryModel.name')) { return ''; }
        return this.booking.purchasableModel.categoryModel.name;
    }
    public get fontSizes() {
        return {
            'body-1': !this.isXS(null),
            'body-2': this.isXS(null),
        };
    }

    get purchaserEmail(){
        return multiNil(this, "booking.purchaserModel") ? '' : `${this.booking.purchaserModel.email}`;
    }
    get purchaserPhone(){
        return multiNil(this, "booking.purchaserModel") ? '' : `${this.booking.purchaserModel.phone}`;
    }

    public get elevationClass() {
        return `elevation-${this.elevation}`;
    }
}
